export default function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20diverse%20shopping%20products%20including%20sneakers%20bags%20perfume%20and%20accessories%20scattered%20artistically%20on%20white%20marble%20surface%2C%20bright%20overhead%20studio%20lighting%2C%20clean%20modern%20editorial%20style%2C%20white%20and%20soft%20gray%20background%2C%20luxury%20product%20photography&width=1800&height=600&seq=cta-bg-v2&orientation=landscape"
          alt="Kakobuy Spreadsheet collection products"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
          Download the Latest Kakobuy Sheet Collection
        </h2>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8">
          Access the complete Kakobuy spreadsheet database with updated product lists, organized categories, easy comparison tools, and beginner-friendly shopping guides.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-4 mb-10">
          <div className="flex items-center gap-2 text-white/80 text-sm">
            <i className="ri-checkbox-circle-fill text-green-400 text-lg"></i>
            <span>Updated Product Lists</span>
          </div>
          <div className="flex items-center gap-2 text-white/80 text-sm">
            <i className="ri-checkbox-circle-fill text-green-400 text-lg"></i>
            <span>Organized Categories</span>
          </div>
          <div className="flex items-center gap-2 text-white/80 text-sm">
            <i className="ri-checkbox-circle-fill text-green-400 text-lg"></i>
            <span>Easy Comparison</span>
          </div>
          <div className="flex items-center gap-2 text-white/80 text-sm">
            <i className="ri-checkbox-circle-fill text-green-400 text-lg"></i>
            <span>Beginner Friendly</span>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-white text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
          >
            Kakobuy Sheet
            <i className="ri-arrow-right-up-line ml-2"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-white text-foreground-900 text-sm font-semibold rounded-full hover:bg-gray-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <i className="ri-shopping-bag-line ml-2"></i>
          </a>
        </div>

        <p className="mt-8 text-xs text-white/50">
          Why thousands of users choose our spreadsheet guides for discovering the best Kakobuy products.
        </p>
      </div>
    </section>
  );
}